export default "__VITE_ASSET__C7A1Euat__"